import React from 'react'
import { useTranslation } from 'react-i18next'
import { zoning_indice_sources } from '@popety-io/types'
import {
  BadgeContainer,
  EditBadgeContainer,
  EditBadgeLabel,
} from './MetricSourceBadge.styles'

/**
 * Source key → short badge label, translated via `metricSourceModal.badges.*`.
 * GEO/REG/EDIT read the same in all four languages; the estimate label does not
 * (EST / SCHÄTZ / STIMA).
 */
export const useMetricSourceBadgeLabel = () => {
  const { t } = useTranslation('ui')
  return (source: string) =>
    t(`metricSourceModal.badges.${source}`, {
      defaultValue: source.toUpperCase(),
    })
}

const PencilIcon = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 12 12"
    fill="none"
    stroke="#b58a00"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path d="M2 10L7.5 4.5L9.5 6.5L4 12Z" />
    <path d="M7.5 4.5L9.5 2.5L11.5 4.5L9.5 6.5" />
  </svg>
)

export interface MetricSourceBadgeProps {
  source: zoning_indice_sources
  faded?: boolean
}

export const MetricSourceBadge: React.FC<MetricSourceBadgeProps> = ({
  source,
  faded = false,
}) => {
  const { t } = useTranslation('ui')
  const getLabel = useMetricSourceBadgeLabel()
  const tooltip = t(`metricSourceModal.tooltips.${source}`, {
    defaultValue: source,
  })
  const label = getLabel(source)

  if (source === 'manual') {
    return (
      <EditBadgeContainer $faded={faded} title={tooltip}>
        <PencilIcon />
        <EditBadgeLabel>{label}</EditBadgeLabel>
      </EditBadgeContainer>
    )
  }

  return (
    <BadgeContainer $source={source} $faded={faded} title={tooltip}>
      {label}
    </BadgeContainer>
  )
}
